import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userActions from '../Actions/userActions';
import * as customerActions from '../Actions/customerActions';
import UserList from "../Components/User/UserList";
import { userService } from "../Services/UserService.js";
import {searchFilterService} from "../Services/SearchFilterService.js";
import { normalize } from 'normalizr';
import {  userSchema, customerSchema, customerListSchema } from '../Schemas/OrderSchema.js';
import {denormalizerService} from "../Services/denormalizerService.js";
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';

import Grid from '@material-ui/core/Grid';

class UserListContainer extends Component {
	constructor(props) {
		super(props);
		this.state={
			selectedTab: 'TRANSLATOR'
		}
		this.onChangeTab = this.onChangeTab.bind(this);
		this.fetchUserRecords = this.fetchUserRecords.bind(this);
		this.switchUserState = this.switchUserState.bind(this);
		this.setSharedUsersView = this.setSharedUsersView.bind(this);
	}
	
	componentDidMount() {
		userService.listUsers()
					.then(response => {return this.fetchUserRecords(response.data);})
					.catch(err => {/*console.log(err);*/});
	}
	
	onChangeTab(index){
		this.setState({selectedTab: index});
	}
	
	fetchUserRecords(responseData){
		var normalizedData = normalize(responseData, [userSchema]);
		this.props.actions.fetchUserRecords(normalizedData.entities.users);
		this.props.actions.fetchCustomerRecords(normalizedData.entities.customers);
		return 1;
	}
	
	switchUserState(user, newState){
		user.enabled=newState;
		let denormlaizedUser = denormalizerService.userDenormalizer(user);
		userService.updateUser(denormlaizedUser)
					.then(response => userService.listUsers())
					.then(response => this.fetchUserRecords(response.data))
//					.then(response => {return this.props.history.go(0);})
					.catch(err => {/*console.log(err);*/});
	}
	
	setSharedUsersView(id, userList){
		userService.setSharedUsersView(id, userList)
					.then(response => userService.listUsers())
					.then(response => this.fetchUserRecords(response.data))
					.catch(err => {/*console.log(err);*/});;
	}
	
	render() {
		//let users = (this.props.search.length > 0) ? (this.props.userRecords.filter(searchFilterService.userFilter) ) : (this.props.userRecords);
		let users = ((typeof this.props.search !== 'undefined') && (this.props.search.length > 0)) ? (searchFilterService.objectFilter(this.props.userRecords, searchFilterService.userFilter)) : (this.props.userRecords);
		//let usersTab = users.filter(user => {return (user.role==this.state.selectedTab);});
		let usersTab = searchFilterService.objectFilter(users, user => {return (user.role==this.state.selectedTab);});
		
		let adminclass="tab";
		let translatorclass="tab";
		let customerclass="tab";
		let pmanagerclass="tab";
		switch(this.state.selectedTab){
			case 'ADMIN': adminclass="tab tabselected";
			break;
			case 'TRANSLATOR': translatorclass="tab tabselected";
			break;
			case 'CUSTOMER': customerclass="tab tabselected";
			break;
			case 'PROJECT_MANAGER': pmanagerclass="tab tabselected";
			break;
		}
		return (
		<div>
			<div className="tabgroup">
			<div  className="row justify-content-around">
				<div className="col-2">
					<span className={adminclass} onClick={() => { this.onChangeTab('ADMIN'); }}>Administrators</span>
				</div>
				<div className="col-2">
					<span className={translatorclass} onClick={() => { this.onChangeTab('TRANSLATOR'); }}>Translators</span>
				</div>
				<div className="col-2">
					<span className={customerclass} onClick={() => { this.onChangeTab('CUSTOMER'); }}>Customers</span>
				</div>
				<div className="col-2">
					<span className={pmanagerclass} onClick={() => { this.onChangeTab('PROJECT_MANAGER'); }}>Project Managers</span>
				</div>
			</div>
			</div>
			<UserList	users={usersTab}
						relatedUsers = {null}
						customers = {this.props.customerRecords}
						setSharedUsersView = {this.setSharedUsersView}
						switchUserState = {this.switchUserState}
						userActions={this.userAction}
			/>
			<Button variant="contained" color="primary" aria-label="New User">
				<Link style={{textDecoration: 'none'}} to={`/userForm/0/0`}>NEW</Link>
			</Button>
		</div>);
	}
}

function mapStateToProps(state, ownProps) {
//	console.log("state.users");
//	console.log(state.users);
	return {userRecords: state.users, customerRecords: state.customers, user: state.user, search: state.search.searchString}
}

function mapDispatchToProps(dispatch) {  
	//return {actions: bindActionCreators(userActions, dispatch)}
	return {actions: bindActionCreators(Object.assign({}, userActions, customerActions), dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserListContainer);  